module.exports = __webpack_public_path__ + "img/24.64e3397d.png";